import { useState, useContext } from 'react';
import Container from "../../components/FormContainer/FormContainer.js";
import Row from "../../components/RowField/RowField.js";
import Section from "../../components/FormSection/FormSection.js";
import Input from "../../components/InputField/InputField.js";
import FunctionButton from "../../components/FunctionButton/FunctionButton.js";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import FormContext from "../../context/FormContext.js";
import StaticDataContext from "../../context/StaticDataContext.js";
import { createList } from "../../utils/utils.js";

function studentContactSection({ staticData, formData, key, index, removeContact }) {
    return (
        <Section key={`contact-${key}`} title={`Student Contact ${index}`}>
            {index !== 1 &&
                <button type="button" onClick={removeContact} value={key}
                    style={{
                        backgroundColor: "var(--accent-color)", color: "var(--white-color)", cursor: "pointer", borderRadius: "var(--button-radius)",
                        appearance: "none", border: "--border-thin"
                    }}>Remove</button>}
            <hr></hr>
            <Row>
                <Input type="select" inputLabel={"Relationship to student"} identifier={`contactRelationship-${key}`} options={createList(staticData, "personRelation")}></Input>
                <Input type="text" inputLabel={"First Name"} identifier={`contactFirstName-${key}`} ></Input>
                <Input type="text" inputLabel={"Last Name"} identifier={`contactLastName-${key}`} ></Input>
                <Input type="select" inputLabel={"Legal Suffix"} identifier={`contactLegalSuffix-${key}`} mandatory={false} options={createList(staticData, "suffix")}></Input>
            </Row>
            <Row>
                <Input type="phone" inputLabel={"Home Phone"} identifier={`contactHomePhone-${key}`} mandatory={false}></Input>
                <Input type="phone" inputLabel={"Work Phone"} identifier={`contactWorkPhone-${key}`} mandatory={false}></Input>
                <Input type="phone" inputLabel={"Cell Phone"} identifier={`contactCellPhone-${key}`} mandatory={false}></Input>
            </Row>
            <Row>
                <Input type="text" inputLabel={"Email Address"} hint={"Required for Edsby portal access"} identifier={`contactEmailAdd-${key}`} mandatory={formData[`isContactEdsbyAccess-${key}`] === "1"} ></Input>
                <Input type="select" inputLabel={<>{"Emergency contact: "}{<i>(Indicate order of contact preference)</i>}</>}
                    identifier={`contactPriority-${key}`}
                    options={[{ label: 1, value: 1 }, { label: 2, value: 2 }, { label: 3, value: 3 }, { label: 4, value: 4 }]}
                    hint={<>Used to determine contact priority for various systems used by the schools.<br /><br /> SchoolMessenger:<br />Priority 1 and 2</>}></Input>
            </Row>
            <Input type="noyesradio" inputLabel={"Does this contact require Edsby portal access?"} identifier={`isContactEdsbyAccess-${key}`} />
            <Input type="noyesradio" inputLabel={"Should this contact be included for school closure notifications?"} identifier={`isContactSchoolClosure-${key}`} />
            <Input type="noyesradio" inputLabel={"Does this contact live with the student?"} identifier={`isContactLivesWith-${key}`} />
            {formData[`isContactLivesWith-${key}`] === "0" &&
                <Input type="text" inputLabel={"Contact Home Address"} identifier={`contactHomeAddress-${key}`} ></Input>
            }
            <hr></hr>
        </Section>
    );
}

function relatedStudentSection({ staticData, key, index, removeStudent, }) {
    return (
        <Section key={`contact-${key}`} title={`Related Student ${index}`}>
            <button type="button" onClick={removeStudent} value={key}
                style={{
                    backgroundColor: "var(--accent-color)", color: "var(--white-color)", cursor: "pointer", borderRadius: "var(--button-radius)",
                    appearance: "none", border: "--border-thin"
                }}>Remove</button>
            <hr></hr>
            <Row>
                <Input type="text" inputLabel={"First Name"} identifier={`relatedStudentFirstName-${key}`} ></Input>
                <Input type="text" inputLabel={"Last Name"} identifier={`relatedStudentLastName-${key}`} ></Input>
            </Row>
            <Row>
                <Input type="select" inputLabel={"School"} identifier={`relatedStudentSchool-${key}`} options={createList(staticData, "schools", { Active: "1" }, "Code", "School_Name", undefined, "School_Name")}></Input>
                <Input type="select" inputLabel={"Grade"} identifier={`relatedStudentGrade-${key}`} options={createList(staticData, "gradeLevels", undefined, undefined, undefined, undefined, "Numeric_Level")}></Input>
                <Input type="select" inputLabel={"Relationship"} identifier={`relatedStudentRelationship-${key}`} mandatory={false} options={createList(staticData, "studentRelation")}></Input>
            </Row>
            <hr></hr>
        </Section>
    );
}

export default function StudentContacts() {
    const { formData, updateFormData } = useContext(FormContext);
    const { staticData } = useContext(StaticDataContext);
    const { injectFormProps } = useInjectFormProps();

    const [uniqueKey, setUniqueKey] = useState(formData["uniqueKey"] ? formData["uniqueKey"] : 1);
    const [contacts, setContacts] = useState(formData["studentContacts"] ? formData["studentContacts"] : formData["studentContacts"] = [{ key: uniqueKey, index: 1 }])
    const [relatedStudents, setRelatedStudents] = useState(formData["relatedStudents"] ? formData["relatedStudents"] : []);

    const updateContacts = () => {
        const newUniqueKey = uniqueKey + 1;
        setUniqueKey(newUniqueKey);
        const newContact = {
            key: newUniqueKey,
            index: contacts.length + 1,
        }
        const updatedContact = [...contacts, newContact]

        setContacts(updatedContact);
        updateFormData({
            ...formData,
            studentContacts: updatedContact,
            uniqueKey: newUniqueKey,
        })
    }


    const removeContact = (e) => {
        const newContacts = contacts.filter((item) => String(item.key) !== String(e.target.value))
        const updatedContacts = newContacts.map((contact, idx) => ({
            ...contact,
            index: idx + 1
        }));

        setContacts(updatedContacts)
        updateFormData({
            ...formData,
            studentContacts: updatedContacts
        })
        console.log(updatedContacts);
    }


    const updateRelatedStudents = () => {
        const newUniqueKey = uniqueKey + 1;
        setUniqueKey(uniqueKey + 1);
        const newRelatedStudent = {
            key: newUniqueKey,
            index: relatedStudents.length + 1
        }
        const updatedRelatedStudent = [...relatedStudents, newRelatedStudent]
        setRelatedStudents(updatedRelatedStudent);
        updateFormData({
            ...formData,
            relatedStudents: updatedRelatedStudent,
            uniqueKey: newUniqueKey,
        })
    }

    const removeRelatedStudents = (e) => {
        const newStudent = relatedStudents.filter((item) => String(item.key) !== String(e.target.value))
        const updatedRelatedStudent = newStudent.map((student, idx) => ({
            ...student,
            index: idx + 1
        }));
        setRelatedStudents(updatedRelatedStudent)
        updateFormData({
            ...formData,
            relatedStudents: updatedRelatedStudent
        })
    }


    return (
        <Container>{injectFormProps(
            <>
                <Section title={"Parent/Guardian Information"}>
                    <Input type="noyesradio"
                        inputLabel={<>{"Is there a custody order in place?"}{<i>(If yes, please provide a copy to the school)</i>}</>}
                        identifier={"hasCustodyOrder"} />
                    {
                        contacts.map((contact) => (
                            studentContactSection({ staticData: staticData, formData: formData, key: contact.key, index: contact.index, removeContact: removeContact })
                        ))
                    }
                    <FunctionButton type="button" classNames={""} label="Add New Contact" onClick={updateContacts} />
                </Section>

                <hr />
                <Section title={"Related Student Information"}>
                    <i>List all siblings, step-siblings, or other students living in the same household who attend a school within GSSD</i>
                    {
                        relatedStudents.map((student) => (
                            relatedStudentSection({ staticData: staticData, formData: formData, key: student.key, index: student.index, removeStudent: removeRelatedStudents })
                        ))
                    }
                    <FunctionButton type="button" classNames={""} label="Add New" onClick={updateRelatedStudents} />
                </Section>
            </>
        )}
        </Container>
    )
}
